import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';

import { RouterStore } from './types';
import { initialRouterState } from './initialState';
import { routerActions } from './routerActions';

export const createRouterStore = () =>
  createStore<RouterStore>()(
    devtools(
      (set) => ({
        ...initialRouterState,
        ...routerActions(set),
      }),
      { anonymousActionType: 'router' }
    )
  );
